// extracted by mini-css-extract-plugin
export var layoutContainer = "_aj-0";
export var layoutContainerNoRounding = "_aj-6";
export var layoutContainerOpen = "_aj-5";
export var layoutContainerResizing = "_aj-1";
export var mainContent = "_aj-2";
export var resizeDivider = "_aj-3";
export var slidePanel = "_aj-4";